import {
  EllipsisVerticalIcon,
  JoonUIColor,
  TextButton,
} from "@joonapp/web-shared"
import type { BaseMessage } from "@sendbird/chat/message"

import { useSendbird } from "./SBProvider"
import { useSBStore } from "./useSBStore"
import Dropdown from "../dropdown/Dropdown"

const MessageMenu = ({
  message,
  isMyMessage,
  setIsMenuOpen,
}: {
  message: BaseMessage
  isMyMessage: boolean
  setIsMenuOpen: (open: boolean) => void
}) => {
  const { setMessageToReplyTo, setMessageToEdit } = useSBStore()
  const { currentChannel, deleteMessage } = useSendbird()

  const onClickReply = () => {
    setIsMenuOpen(false)
    setMessageToReplyTo(message)
  }

  const onClickDelete = async () => {
    if (!currentChannel) return
    deleteMessage(currentChannel?.url, message)
  }

  const onClickEdit = () => {
    if (!message) return
    setIsMenuOpen(false)
    setMessageToEdit(message)
  }

  if (!isMyMessage && message.parentMessage) return null

  return (
    <Dropdown
      trigger={
        <TextButton onClick={() => {}} style={{ marginBottom: "auto" }}>
          <EllipsisVerticalIcon size={20} color={JoonUIColor.text.secondary} />
        </TextButton>
      }
      items={[
        ...(isMyMessage
          ? [
              { label: "Edit", onClick: onClickEdit },
              { label: "Delete", onClick: onClickDelete },
            ]
          : [{ label: "Reply", onClick: onClickReply }]),
      ]}
      position="bottom"
      onOpenChange={(open) => setIsMenuOpen(open)}
    />
  )
}

export default MessageMenu
